/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForecastModelAggregationReport = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ForecastModelAggregationReport model module.
   * @module model/ForecastModelAggregationReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ForecastModelAggregationReport</code>.
   * @alias module:model/ForecastModelAggregationReport
   * @class
   */
  var exports = function() {
    var _this = this;





  };

  /**
   * Constructs a <code>ForecastModelAggregationReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ForecastModelAggregationReport} obj Optional instance to populate.
   * @return {module:model/ForecastModelAggregationReport} The populated <code>ForecastModelAggregationReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('IndicatorID')) {
        obj['IndicatorID'] = ApiClient.convertToType(data['IndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Date')) {
        obj['Date'] = ApiClient.convertToType(data['Date'], 'Date');
      }
      if (data.hasOwnProperty('CurrentTotal')) {
        obj['CurrentTotal'] = ApiClient.convertToType(data['CurrentTotal'], 'Number');
      }
      if (data.hasOwnProperty('AggregatedTotal')) {
        obj['AggregatedTotal'] = ApiClient.convertToType(data['AggregatedTotal'], 'Number');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} IndicatorID
   * @default 0
   */
  exports.prototype['IndicatorID'] = 0;
  /**
   * @member {Date} Date
   */
  exports.prototype['Date'] = undefined;
  /**
   * @member {Number} CurrentTotal
   * @default 0.0
   */
  exports.prototype['CurrentTotal'] = 0.0;
  /**
   * @member {Number} AggregatedTotal
   * @default 0.0
   */
  exports.prototype['AggregatedTotal'] = 0.0;



  return exports;
}));


